import React, { useEffect } from "react";

const ApiResponseModal = ({
  show,
  onClose,
  type = "success", // success | error | warning | info
  title,
  message,
  autoClose = true,
  duration = 50000,
}) => {
  useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [show, autoClose, duration, onClose]);

  if (!show) return null;

  const config = {
    success: {
      emoji: "✅",
      color: "#198754",
      bg: "#eafaf1",
    },
    error: {
      emoji: "❌",
      color: "#dc3545",
      bg: "#fdecec",
    },
    warning: {
      emoji: "⚠️",
      color: "#ffc107",
      bg: "#fff8e1",
    },
    info: {
      emoji: "ℹ️",
      color: "#0d6efd",
      bg: "#eef4ff",
    },
  }[type];

  return (
    <>
      {/* INLINE CSS */}
      <style>{`
        .api-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }

        .api-modal {
          background: #fff;
          width: 90%;
          max-width: 340px;
          border-radius: 14px;
          padding: 22px 18px;
          text-align: center;
          box-shadow: 0 20px 50px rgba(0,0,0,0.25);
          animation: scaleIn 0.3s ease;
        }

        .api-modal-icon {
          font-size: 42px;
          margin-bottom: 8px;
        }

        .api-modal-title {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 6px;
        }

        .api-modal-message {
          font-size: 14px;
          color: #555;
          line-height: 1.6;
          margin-bottom: 14px;
        }

        .api-modal-btn {
          background: ${config.color};
          color: #fff;
          border: none;
          border-radius: 8px;
          padding: 8px 14px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          width: 100%;
        }

        @keyframes scaleIn {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>

      <div className="api-modal-overlay" onClick={onClose}>
        <div
          className="api-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ background: config.bg }}
        >
          <div className="api-modal-icon">{config.emoji}</div>

          {title ==="Login Required" ? <h4  className="modal-title" data-bs-toggle="modal"
  data-bs-target="#loginSignUpModal">{title}</h4>: <h4
            className="api-modal-title"
            style={{ color: config.color }}
          >
            {title}
          </h4>}

          <p className="api-modal-message">{message}</p>

          {!autoClose && (
            <button className="api-modal-btn" onClick={onClose}>
              OK
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ApiResponseModal;
